/* eslint-disable prettier/prettier */
import React from "react";
import { Box, Button, Container } from "@mui/material";
import { getDatabase, ref, set, onValue } from "firebase/database";
import { ProductDetail } from "../types/product";

export const Test = () => {
  const writeData = () => {
    const productId = 1;
    const db = getDatabase();

    const product: ProductDetail = {
      id: 0,
      name: "Burmese ruby",
      price: 700,
      size: 8,
      specifications: [
        "Burmese Ruby",
        "Zambian Emerald",
        "Orange Sapphire",
        "Gold 18KGP",
      ], 
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/niran-fce3f.appspot.com/o/products%2Fresized-10.jpg"
    };
    set(ref(db, "products/" + productId), product);
  };

  const readData = () => {
    const db = getDatabase();
    const productRef = ref(db, "products");
    onValue(productRef, (snapshot) => {
      const data = snapshot.val();
      console.log("read data:", data);
    })
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ display: "flex", flexDirection: "column", height: 120, justifyContent: "space-between", m: 3 }}>
        <div>Test Screen</div>
        <Button variant="contained" onClick={writeData}>
          write data
        </Button>

        <Button variant="contained" onClick={readData}>
          read data
        </Button>
      </Box>
      
    </Container>
  );
};
